<style lang="scss">
  .people-button{
    .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn{
        margin: 0px;  
        height: 29px;
    }
    .ivu-input-group-append, .ivu-input-group-prepend{
        padding: 0px;
    }
    .ivu-btn {
        padding: 6px 10px;
    }
  }
</style>


<template>
    <div>
    <Affix v-if="this.$route.params.groupType != 'interest'" :offset-top="84">
        <Card shadow :padding="10" :style="{borderRadius: '0'}">
          <div @keyup.enter="searchPeople" style="display:flex" class="ivu-input-wrapper ivu-input-type people-button">
            <Input v-model="filter" placeholder="Search...">
              <Button @click="searchPeople" slot="append" icon="ios-search"></Button>
              <Button @click="showModal" slot="append" icon="android-settings"></Button>
              <!-- <Icon @click="showModal" style="width: auto;padding-right: 0px;height: 32px;padding-left: 8px;line-height: 33px;" size="20" type="funnel"></Icon> -->
            </Input>
            <!-- <select @change="advanceClick(filterCategory)" v-model="filterCategory" style="width: 70px;padding-right: 0px;height: 32px;top: 1px;margin-left:2px" class="ivu-select-selection custom-ui-select has-margin-bottom">
                <option disabled="false" v-for="item in advanceSelect" :value="item.value" :key="item.value">{{ item.label }}</option>
            </select> -->
          <!-- <Icon @click="showModal" style="width: auto;padding-right: 0px;height: 32px;padding-left: 8px;line-height: 33px;" size="20" type="funnel"></Icon> -->
          </div>
        </Card>
    </Affix>
        <span style="display: flex;height: 60vh;align-items: center;justify-content: center;" v-if="users.subscribers.length == 0">No Results Found</span>
        <Card v-if="!isLoading" v-for="user in users.subscribers" :key="user.id"  shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2'}" :padding="0">
            <div class="resources-item-header" :style="{padding: '10px 10px 8px'}" @click="viewUser(user)">
                <slot name="sub-avatar">
                    <Avatar shape="circle" size="large" :src="userDisplayImage(user)"  :style="{float:'left', marginRight: '10px', background: '#ddd'}" />
                </slot>
                <p>
                    <slot name="sub-name"><b>{{user.display_name}}</b>
                    </slot>
                </p>
                <slot name="sub-title">
                    <small style="color:#aaa;height:20px;display:block;min-width:100px">
                    {{user.city || user.province || user.region || user.country}}
                    </small>
                </slot>
            </div>
        </Card>
        <div v-if="users.next_link" style="margin-bottom:10px;margin-top:10px" span="24">
          <Button style="width:50%;display:flex;margin: 0 auto;justify-content:center;backgroundColor:white" @click="loadMorePerson" default :loading="!isLoadingLoadmore">
            <span v-if="isLoadingLoadmore" style="color:#2d8cf0">Load More</span>
            <span v-else>Loading...</span>
          </Button>
        </div>
 
        <ModalHolder title="test" m-top="20" m-height="50vh" :is-show="isShowFilterModal">
          <h3 slot='mheader'>Filter</h3>
          <div slot='mcontent'>
            <h4 style="padding:16px 0px 8px">Name:</h4>
            <Input placeholder="Search..."/>
            <h4 style="padding:24px 0px 8px">Location:</h4>
            <div v-for="(item,i) in advanceSelect" :key="i" style="display:flex;padding:4px 0px"> 
              <!-- <select @change="advanceClick(filterCategory)" v-model="filterCategory" style="width: 70px;margin-right:4px;height: 32px; line-height:33px" class="ivu-select-selection custom-ui-select has-margin-bottom">
                  <option disabled="false" v-for="item in advanceSelect" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select> -->
              <span style="width:60px;line-height:32px;margin-right:8px">{{item.label}}: </span>
              <Input placeholder="Search..."/>
            </div>
          </div>
          <div slot='mfooter'>
            <Button @click="dismissModal" type="primary">Ok</Button>
          </div>
        </ModalHolder>
    </div>
</template>

<script>
import Utils from '@/utils.js'
import ModalHolder from "@/components/ModalHolderComponent";
export default {
  name: 'PeopleListComponent',
  props: {
    users: {
      required: true,
    }
  },
  components: {
    ModalHolder
  },
  data(){
    return {
      filter:'',
      filterCategory:'city',
      advanceSelect: [
        {
            value: 'city',
            label: 'City'
        },
        {
            value:  'province',
            label: 'Province'
        },
        {
            value:  'country',
            label: 'Country'
        }],
      showMyndModal : true
    }
  },
  methods: {
    searchPeople(){
      this.$store.dispatch("feed/searchRecentUsers",{text:this.filter, group_id:this.$route.query.id})
    },
    viewUser (item) {
      this.$router.push({ path: '/profile/' + item.id })
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    getUserLabel(permissionCode,item){
        if(this.getPermissionLabel(permissionCode) == "Member"){
          return item.city || item.province || item.region || item.country
        }else{
          return this.getPermissionLabel(permissionCode)
        }
    },
    loadMorePerson(){ 
        this.$store.dispatch("feed/loadMoreSearchRecentUsers",this.users.next_link)
    },
    advanceClick(v){
      this.showMyndModal = true
    },
    dismissModal() {
      this.$store.commit('base/setFilterModal', false);
    },
    showModal() {
      this.$store.commit('base/setFilterModal', true);
    }
  },
  computed:{
    isLoadingLoadmore:{
      get () {
        return !this.$store.state.feed.isLoadingMoreRecentSearchUsers;
      }
    },
    isLoading() {
      return this.$store.state.feed.isLoadingRecentSearchUsers;
    },
    isShowFilterModal: {
      get() {
        return this.$store.state.base.isFilterModal
      }
    }
  }
}
</script>
